import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PLACEHOLDERS = {
  company_name: "[NOMBRE EMPRESA]", tax_id: "[NIF]", address: "[DIRECCIÓN]", email: "[EMAIL]",
  dpo_email: "", registry: "", jurisdiction_city: "[CIUDAD]", website: "",
};
let cache = null;
let inflight = null;

export const invalidateLegalInfo = (data) => { cache = data || null; };

export default function useLegalInfo() {
  const [info, setInfo] = useState(cache);
  useEffect(() => {
    if (cache) return;
    inflight = inflight || axios.get(`${API}/legal-info`).then((r) => r.data).catch(() => ({}));
    inflight.then((d) => { cache = d; setInfo(d); });
  }, []);
  const raw = info || {};
  const L = (k) => raw[k] || PLACEHOLDERS[k];
  const complete = ["company_name", "tax_id", "address", "email"].every((k) => raw[k]);
  return { info: raw, L, complete, loaded: !!info };
}
